import PromptProvider from '@root/lib/components/Prompt';
import ReactDOM from 'react-dom';
import MyChoice from './MyChoice';

const root = document.getElementById('my-choice-root');
const settings = JSON.parse(root.dataset.settings);
const boxSku = Shopify.product.variants[0].sku;

ReactDOM.render((
    <PromptProvider>
        <MyChoice boxSku={boxSku} settings={settings} />
    </PromptProvider>
), root);